export default __webpack_public_path__ + "static/media/avax-cheers-pepe.259493e0.jpeg";